import axios from "axios";
import React, { Component } from "react";
import { toast } from "react-toastify";
import BarTitle from "../../components/BarTitle";
import constants from "../../constants";
import "./styles.css";

import { Link } from "react-router";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

class DisableDriver extends Component {
  constructor(props) {
    super(props);

    this.state = {
      iddriver: null,
      driverData: null,
      allDrivers: [],
      disabledDriversList: [],
    };

    this.disableDriverId = this.disableDriverId.bind(this);
    this.enableDriverId = this.enableDriverId.bind(this);
    this.getAllDisabledDrivers = this.getAllDisabledDrivers.bind(this);
  }

  componentDidMount() {
    this.getAllDisabledDrivers();
  }

  handleAPI = async (e) => {
    this.setState({
      iddriver: e.target.value,
    });
    const url =
      constants().URL_SERVICE + "establishment/establishment/get_drivers_list/";
    await axios
      .get(url, {
        headers: { Authorization: "Token " + localStorage.token },
      })
      .then((response) => {
        this.setState({ allDrivers: response.data.drivers });
      })
      .catch((error) => this.setState({ error: true }));
    let convertToLc = e.target.value;
    let filterData = this.state.allDrivers.filter((e) => {
      let allDriversId = e.id.toString();
      return allDriversId.indexOf(convertToLc) !== -1;
    });
    let filterDriverData = this.state.allDrivers.filter((e) => {
      let allDriversId = e.id.toString();
      return allDriversId == convertToLc;
    });
    if (filterDriverData.length === 0) {
      filterDriverData = null;
    }
    this.setState({
      driverData: filterDriverData,
    });
    this.setState({
      allDrivers: filterData,
    });
  };

  getAllDisabledDrivers() {
    const listRacesUrl =
      constants().URL_SERVICE +
      `establishment/establishment/get_all_drivers_block/`;

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
      },
    };
    try {
      axios.get(listRacesUrl, customConfig).then((response) => {
        this.setState({ disabledDriversList: response.data.data });
      });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  disableDriverId(id) {
    const url =
      constants().URL_SERVICE + "establishment/establishment/add_block/";
    try {
      axios
        .post(
          url,
          { driver_id: id },
          { headers: { Authorization: "Token " + localStorage.token } }
        )
        .then((response) => {
          toast.success("Motorista desabilitado com sucesso!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        })
        .catch((error) => {
          this.setState({ error: true });
          toast.error("Ocorreu um Erro Durante o Bloqueio", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  enableDriverId(id) {
    const url =
      constants().URL_SERVICE + "establishment/establishment/remove_block/";
    try {
      axios
        .post(
          url,
          { driver_id: id },
          { headers: { Authorization: "Token " + localStorage.token } }
        )
        .then((response) => {
          toast.success("Motorista habilitado com sucesso!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        })
        .catch((error) => {
          this.setState({ error: true });
          toast.error("Ocorreu um Erro Durante o Bloqueio", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  render() {
    return (
      <div>
        <BarTitle name="Bloquear entregador" />
        <div className="wrapper-md">
          <div className="panel panel-default">
            <div
              className="panel-heading"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <text>
                Lista de motoristas bloqueados e bloqueio de motoristas
              </text>
            </div>
            <div className="panel-body">
              <div>
                <div style={{ display: "flex", flexDisrection: "row" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label
                      style={{ marginLeft: "15px" }}
                      label-default=""
                      className="control-label"
                    >
                      ID Motorista
                    </label>
                    <div
                      style={{ width: "100%", display: "flex" }}
                      className="col-md-12"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <input
                          type="number"
                          onChange={this.handleAPI}
                          autocomplete="off"
                          title="Insira o ID do motorista"
                          rows="1"
                          ref="driverid"
                          value={this.state.iddriver}
                        />
                      </div>
                    </div>
                    {this.state.driverData
                      ? this.state.driverData.map((res) => {
                          return (
                            <div
                              style={{ marginLeft: "15px", marginTop: "15px" }}
                            >
                              {res.id == this.state.iddriver ? (
                                <div
                                  className="card-driver-content"
                                  style={{ borderBottom: "none" }}
                                >
                                  <img
                                    src={res.profile_picture}
                                    style={{ alignSelf: "center" }}
                                    width="80"
                                    height="80"
                                  />
                                  <div className="card-driver-text">
                                    <text className="font-bold">ID: </text>
                                    <text>{res.id}</text> <br />
                                    <text className="font-bold">Nome: </text>
                                    <text>{res.label} </text> <br />
                                    <text className="font-bold">Celular: </text>
                                    <text>{res.phone} </text> <br />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          );
                        })
                      : null}
                    <div className="card-solicitation-buttons">
                      {this.state.driverData && (
                        <div>
                          <Link
                            type="button"
                            style={{ marginLeft: "15px", padding: "5px" }}
                            className="btn btn-info btn-lg"
                            onClick={async () => {
                              this.disableDriverId(this.state.iddriver);
                              delay(1000);
                              await this.getAllDisabledDrivers();
                              if (
                                this.state.iddriver !== "" &&
                                this.state.iddriver !== null &&
                                (this.state.driverData === null ||
                                  this.state.driverData === [] ||
                                  this.state.driverData === "")
                              ) {
                                toast.error(
                                  "Erro: Aguarde o carregamento dos dados do motorista ou insira o ID novamente!",
                                  {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                  }
                                );
                              }
                              this.setState({ iddriver: '' });
                              delay(200);
                              this.setState({ driverData: null });
                            }}
                          >
                            Bloquear
                          </Link>
                          <Link
                            type="button"
                            style={{ marginLeft: "15px", padding: "5px" }}
                            className="btn btn-danger btn-lg"
                            onClick={async () => {
                              this.enableDriverId(this.state.iddriver);
                              delay(200);
                              await this.getAllDisabledDrivers();
                              if (
                                this.state.iddriver !== "" &&
                                this.state.iddriver !== null &&
                                (this.state.driverData === null ||
                                  this.state.driverData === [] ||
                                  this.state.driverData === "")
                              ) {
                                toast.error(
                                  "Erro: Aguarde o carregamento dos dados do motorista ou insira o ID novamente!",
                                  {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                  }
                                );
                              }
                              this.setState({ iddriver: '' });
                              delay(1000);
                              this.setState({ driverData: null });
                            }}
                          >
                            Desbloquear motorista
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <label
                      style={{ fontWeight: "bold" }}
                      label-default=""
                      className="control-label"
                    >
                      Motoristas bloqueados
                    </label>
                    <div className="card-main-disable">
                      {this.state.disabledDriversList ? (
                        this.state.disabledDriversList.map((driver, i) => (
                          <div
                            className="card-driver-content"
                            style={{  }}
                          >
                            <img
                              src={driver.driver.profile_picture}
                              style={{ alignSelf: "center" }}
                              width="80"
                              height="80"
                            />
                            <div className="card-driver-text">
                              <text className="font-bold">ID: </text>
                              <text>{driver.driver.id}</text> <br />
                              <text className="font-bold">Nome: </text>
                              <text>{driver.driver.full_name} </text> <br />
                              <text className="font-bold">Celular: </text>
                              <text>{driver.driver.phone} </text> <br />
                            </div>
                          </div>
                        ))
                      ) : (
                        <tr>
                          <td>TESTINHO</td>
                        </tr>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DisableDriver;



// WEBPACK FOOTER //
// ./src/views/DisableDriver/index.js